"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,1.8A10.2,10.2,0,1,0,22.12,12.09v0A10.16,10.16,0,0,0,12.05,1.8Z",
    fill: "#054966"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.84,20.79a.42.42,0,0,1-.3-.12A12.22,12.22,0,0,1,3.61,3.39L4,3a.43.43,0,0,1,.57.63h0a11.36,11.36,0,0,0-.71,16.05l.32.34a.42.42,0,0,1-.3.72Z",
    fill: "#054966"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.22,20.76a.42.42,0,0,1-.3-.72A11.36,11.36,0,0,0,19.81,4l-.31-.29A.42.42,0,0,1,19.93,3L20,3a12.22,12.22,0,0,1,.77,17.26l-.32.34A.42.42,0,0,1,20.22,20.76Z",
    fill: "#054966"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.25,9.93v1.69H8.39v.88H6.25v1.73H9v.91H5.11V9H9v.9Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.08,9a4,4,0,0,1,1,.11,2,2,0,0,1,.7.33,1.27,1.27,0,0,1,.4.51,1.72,1.72,0,0,1,.13.68,1.33,1.33,0,0,1-.06.41,1.2,1.2,0,0,1-.2.37,1.46,1.46,0,0,1-.34.31,2,2,0,0,1-.49.24q1.26.28,1.26,1.36a1.74,1.74,0,0,1-.15.72,1.58,1.58,0,0,1-.43.57,2,2,0,0,1-.7.37,3,3,0,0,1-1,.14H10V9Zm-1,.88v1.77H12a1.52,1.52,0,0,0,.88-.21.77.77,0,0,0,.3-.67.8.8,0,0,0-.27-.68,1.42,1.42,0,0,0-.85-.2Zm1.15,4.36a1.62,1.62,0,0,0,.53-.08.91.91,0,0,0,.34-.2.74.74,0,0,0,.19-.3,1.11,1.11,0,0,0,.06-.36,1,1,0,0,0-.06-.36.67.67,0,0,0-.2-.27.93.93,0,0,0-.35-.17,2,2,0,0,0-.51-.06H11.11v1.79Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.81,10.14a.39.39,0,0,1-.11.13.24.24,0,0,1-.14,0,.36.36,0,0,1-.19-.07L18.12,10a2,2,0,0,0-.34-.15,1.4,1.4,0,0,0-.45-.07,1.36,1.36,0,0,0-.41.06.86.86,0,0,0-.3.16.64.64,0,0,0-.18.24.79.79,0,0,0-.06.31.54.54,0,0,0,.12.36,1,1,0,0,0,.32.24,3,3,0,0,0,.45.18l.52.17a4.88,4.88,0,0,1,.52.21,1.8,1.8,0,0,1,.45.3,1.38,1.38,0,0,1,.32.45,1.57,1.57,0,0,1,.12.65,2.11,2.11,0,0,1-.14.78,1.79,1.79,0,0,1-.41.63A2,2,0,0,1,18,15a2.44,2.44,0,0,1-.9.15,2.9,2.9,0,0,1-.57-.06,3,3,0,0,1-.54-.16,2.94,2.94,0,0,1-.49-.25,2.35,2.35,0,0,1-.41-.33l.33-.55a.35.35,0,0,1,.11-.1.28.28,0,0,1,.14,0,.4.4,0,0,1,.23.09l.29.19a2.31,2.31,0,0,0,.4.19,1.51,1.51,0,0,0,.54.09,1.12,1.12,0,0,0,.75-.23.83.83,0,0,0,.27-.66A.62.62,0,0,0,18,13a1,1,0,0,0-.32-.26,2.36,2.36,0,0,0-.45-.18l-.52-.16a4.47,4.47,0,0,1-.52-.2,1.69,1.69,0,0,1-.45-.31,1.4,1.4,0,0,1-.32-.47,1.81,1.81,0,0,1-.12-.7,1.69,1.69,0,0,1,.52-1.21,1.89,1.89,0,0,1,.63-.39,2.29,2.29,0,0,1,.85-.15,2.86,2.86,0,0,1,1,.17,2.26,2.26,0,0,1,.78.47Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;